import React from "react";
import { Routes, Route } from "react-router-dom";
import ChatbotPage from "../pages/ChatbotPage";

const ChatbotRoutes = () => {
  return (
    <Routes>
      {/* Index: /chatbot */}
      <Route index element={<ChatbotPage />} />

      {/* (Opcional) si luego agregas subrutas, ej: /chatbot/historial */}
      {/* <Route path="historial" element={<ChatbotHistoryPage />} /> */}

      {/* Fallback */}
      <Route path="*" element={<ChatbotPage />} />
    </Routes>
  );
};

export default ChatbotRoutes;